var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "cm-like",
    class: {
      'cm-like--liked': _vm.liked,
      'is-flashing': _vm.likeLoading,
    },
    attrs: {
      "data-company": _vm.company.id
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.toggleLike($event)
      }
    }
  }, [_c('i', {
    staticClass: "ss-icon"
  }, [_vm._v("heart")])])
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-08390ab3","hasScoped":true}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./app/javascript/company/heart.vue
// module id = null
// module chunks = 